var halfkana = /[\uFF61-\uFF9F]+/g;
var hiragana = /[\u3041-\u3096]/g;
var z2hCheck = {
    type: ['email', 'tel', 'url'],
    inputmode: ['numeric', 'decimal'],
    autocomplete: ['email', 'tel', 'postal-code'],
};
var kanaCheck = {
    autocomplete: ['kana'],
};
function check(elem, checker) {
    return Object.entries(checker).some(function (_a) {
        var key = _a[0], values = _a[1];
        return values.includes(elem.getAttribute(key));
    });
}
export function normalize(str, opts) {
    if (opts === void 0) { opts = {}; }
    if (opts instanceof Element) {
        opts = { z2h: check(opts, z2hCheck), katakana: check(opts, kanaCheck) };
    }
    str = opts.z2h ? str.normalize('NFKC') : str.normalize('NFC').replace(halfkana, function (s) { return s.normalize('NFKC'); });
    if (opts.katakana)
        str = str.replace(hiragana, function (s) { return String.fromCharCode(s.charCodeAt(0) + 0x60); });
    return str;
}
